import { render, staticRenderFns } from "./DispatchFormV2.html?vue&type=template&id=ae9c4dcc&scoped=true&external"
import script from "./DispatchFormV2.js?vue&type=script&lang=js&external"
export * from "./DispatchFormV2.js?vue&type=script&lang=js&external"
import style0 from "./DispatchFormV2.vue?vue&type=style&index=0&id=ae9c4dcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae9c4dcc",
  null
  
)

export default component.exports